import containsNumber from 'utils/containsNumber'

// google places API returns a `street_number` and `route` which we combine into a `street` to be
// stored in our DB. It's not good if we allow users to create accounts without street numbers,
// because those probably aren't valid property addresses
const validateStreet = (street: string) => containsNumber(street)

export default validateStreet
